import React, { useEffect, useState, useRef, useMemo } from "react"
import { withRouter, Link } from "react-router-dom"
import {
  Card,
  CardBody,
  Col,
  Row,
  Modal,
  Button,
  ModalHeader,
  ModalBody,
  Label,
  FormFeedback,
  Input,
  Form,
  Badge,
} from "reactstrap"
import Select from "react-select"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import * as Yup from "yup"
import { useFormik } from "formik"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit"
import BootstrapTable from "react-bootstrap-table-next"
import {
  statusTypes,
  guestStatusTypes,
  messageTitle,
  guestAccessType,
  vehicleTypes,
} from "constants/common"
import moment from "moment"

import { mobileRegex, iuRegex,vehicleRegex } from "../../helpers/validator"
import Switch from "react-switch"
import { dateformat } from "config"
import DeleteModal from "components/Common/DeleteModal"
import { getCarParks as onGetCarparks } from "../../store/carpark/actions"
import { getUsers as onGetUsers } from "store/user/actions"
import {
  getGuests as onGetGuests,
  addNewGuest as onAddNewGuest,
  updateGuest as onUpdateGuest,
  deleteGuest as onDeleteGuest,
  clearMessage,
  getExportGuest,
  resetExportFileData,
} from "store/guest/actions"
import OffSymbol from "components/Common/OffSymbol"
import OnSymbol from "components/Common/OnSymobl"
import { isEmpty, map, orderBy } from "lodash"
import toastr from "toastr"
import "toastr/build/toastr.min.css"

//redux
import { useSelector, useDispatch } from "react-redux"

const getColor = status => {
  if (status == statusTypes.Removed) {
    return "danger"
  } else if (
    status == statusTypes.Available ||
    status == statusTypes.Approved
  ) {
    return "success"
  } else if (status == statusTypes.Blacklist) {
    return "dark"
  } else {
    return "warning"
  }
}

const getUser = user => {
  if (user) {
    return {
      value: user?._id || "",
      label: user?.name || "",
    }
  }
  return null
}


const sizePerPage = 25;
const defaultStartDate = moment().startOf("M")
const defaultEndDate = moment()

const GuestList = props => {
  const dispatch = useDispatch()
  const carparkRef = useRef();
  const [guest, setGuest] = useState()
  const [vehicleType, setVehicleType] = useState(vehicleTypes.car)
  const [fileType, setFileType] = useState({ label: "PDF", value: "pdf" })
  const [carParkList, setCarparkList] = useState([])

  const [startDate, setStartDate] = useState(
    defaultStartDate.format(dateformat.default)
  )
  const [endDate, setEndDate] = useState()

  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      guestName: (guest && guest.guestName) || "",
      guestVehicleNumber: (guest && guest.guestVehicleNumber) || "",
      guestInVehicleUnit: (guest && guest.guestInVehicleUnit) || "",
      visitDate: moment(guest?.visitDate || new Date()).format("YYYY-MM-DD"),
      purpose: guest?.purpose || "",
    },
    validationSchema: Yup.object({
      guestName: Yup.string()
        .required("Please Enter Your Name")
        .min(5, "Must be at least 5 characters"),
      guestVehicleNumber: Yup.string()
        .required("A valid Vehicle Number is required")
        .matches(vehicleRegex, "Invalid Vehicle Number")
        .max(8, "Invalid Vehicle Number")
        .min(3, "Invalid Vehicle Number"),
      guestInVehicleUnit: Yup.string()
        .matches(iuRegex, "Invalid In-Unit Vehicle Number")
        .max(10, "Invalid In-Unit Vehicle Number")
        .min(10, "Invalid In-Unit Vehicle Number"),
    }),
    onSubmit: values => {
      if (isEmpty(selectedSponsor)) {
        setCustValidation({ validSponsor: false, validCarpark: true })
        return
      }
      if (isEmpty(selectedCarpark)) {
        setCustValidation({ validSponsor: true, validCarpark: false })
        return
      }
      //console.log("complimentaryAccess :>> ", complimentaryAccess)

      if (isEdit) {
        const updateGuest = {
          id: guest.id,
          guestName: values.guestName,
          sponsor: selectedSponsor?.value || "",
          guestVehicleNumber: values.guestVehicleNumber,
          guestInVehicleUnit: values.guestInVehicleUnit,
          visitDate: moment(values["visitDate"]).format("YYYY-MM-DD"),
          status: complimentaryAccess
            ? guestAccessType.Complimentary
            : guestAccessType.Approved,
          carPark: selectedCarpark.value,
          purpose: values["purpose"],
          statusChangeReason: values["purpose"],
          updatedAt: moment().format(),
          approveDate: moment().format(),
          vehicleType,
        }
        // update guest
        dispatch(onUpdateGuest(updateGuest))
        validation.resetForm()
        setIsEdit(false)
      } else {
        const newGuest = {
          guestName: values["guestName"],
          sponsor: selectedSponsor?.value || "",
          guestVehicleNumber: values["guestVehicleNumber"],
          guestInVehicleUnit: values["guestInVehicleUnit"],
          scheduled: null,
          transactions: null,
          status: statusTypes.Approved,
          visitDate: moment(values["visitDate"]).format("YYYY-MM-DD"),
          status: complimentaryAccess
            ? guestAccessType.Complimentary
            : guestAccessType.Approved,
          carPark: selectedCarpark.value,
          purpose: values["purpose"],
          statusChangeReason: values["purpose"],
          createdAt: moment().format(),
          approveDate: moment().format(),
          vehicleType,
        }
        // save new guest
        dispatch(onAddNewGuest(newGuest))
      }
      toggle()
    },
  })

  const { guests, userList, message, error, file, pagination } = useSelector(
    state => ({
      guests: state.guests.guestList,
      message: state.guests.message,
      error: state.guests.error,
      userList: state.users.userList,
      //carParkList: state.carPark.carParkList,
      file: state.guests.file,
      pagination: state.guests.pagination,
    })
    // console.log(pagination)
  )
  const [complimentaryAccess, setComplimentaryAccess] = useState(false)
  const [modal, setModal] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [selectedSponsor, setSelectedSponsor] = useState(
    getUser(guest?.sponsor || null)
  )
  const [selectedCarpark, setSelectedCarpark] = useState(null)
  const [currentPage, setCurrentPage] = useState(1)
  const [filterStatus, setFilterStatus] = useState({
    value: guestStatusTypes.Approved,
    label: guestStatusTypes.Approved,
  })
  const [accessStatus, setAccessStatus] = useState({
    value: guestAccessType.Approved,
    label: guestAccessType.Approved,
  })

  const [customValidation, setCustValidation] = useState({
    validSponsor: true,
    validCarpark: true,
  })
  const [carparks, setCarparks] = useState([])
  const [users, setUsers] = useState([])
  const { SearchBar } = Search

  const [searchKey, setSearchKey] = useState("");
  const [filteredRes, setFilteredRes] = useState([]);

  useEffect(() => {
    if (guests) {
      // Sort guests according to guestId (in descending order)
      /*       guests.sort((guest1, guest2) => {
              const id1 = guest1.guestId;
              const id2 = guest2.guestId;
              // Compare the 2 ids
              if (id1 < id2) return 1;
              if (id1 > id2) return -1;
              return 0;
            }); */
      setFilteredRes(guests);
    }
  }, [guests]);

  useEffect(() => {
    // if(searchKey !== ""){
    //   const regex = new RegExp(searchKey.toLowerCase(), 'g');
    //   let filteredList = guests?.filter((el)=>{
    //     if(regex.test(el?.guestId.toLowerCase())){
    //       return el;
    //     }
    //     if(regex.test(el?.guestName.toLowerCase())){
    //       return el;
    //     }
    //     if(regex.test(el?.guestVehicleNumber.toLowerCase())){
    //       return el;
    //     }
    //     if(regex.test(el?.guestInVehicleUnit.toLowerCase())){
    //       return el;
    //     }
    //     if(regex.test(el?.sponsor?.name.toLowerCase())){
    //       return el;
    //     }
    //   });
    //   setFilteredRes(filteredList);
    // }else{
    //   setFilteredRes(guests);
    // }
    if (searchKey.length >= 2 || searchKey == "") {
      setCurrentPage(1);
      dispatch(onGetGuests({ status: filterStatus.value, page: currentPage, size: sizePerPage, search: searchKey , startDate: startDate, endDate: endDate}));
    }
  }, [searchKey]);

  const pageOptions = {
    page: currentPage,
    sizePerPage: sizePerPage,
    totalSize: pagination?.totalItems || 0, // replace later with size(users),
    custom: true,
    totalPages: pagination?.totalPages || 0,
    onPageChange: setCurrentPage,
  }

  useEffect(() => {
    dispatch(onGetCarparks({ status: "Available" }))
    if (isEmpty(userList)) {
      dispatch(
        onGetUsers({ status: [statusTypes.Approved, statusTypes.Available] })
      )
    }
    setTimeout(() => {
      dispatch(onGetGuests({ status: filterStatus.value, search: searchKey, page: currentPage, size: sizePerPage, startDate: startDate, endDate: endDate }))
    }, 500)
  }, [])

  useEffect(() => {
    dispatch(onGetGuests({ status: filterStatus.value, search: searchKey, page: currentPage, size: sizePerPage, startDate: startDate, endDate: endDate }))
  }, [currentPage]);

  useEffect(() => {
    if (!isEmpty(filteredRes) && !!isEdit) {
      setIsEdit(false)
    }
  }, [filteredRes])

  useMemo(() => {
    if (!isEmpty(carParkList)) {
      setCarparks(carParkList)
    } else {
      dispatch(onGetCarparks({ status: "Available" }))
    }
  }, [carParkList])

  useMemo(() => {
    if (!isEmpty(userList)) {
      setUsers(userList)
    } else {
      onGetUsers({ status: [filterStatus.value] })
    }
  }, [userList])

  useMemo(() => {
    if (message) {
      message == "PDF file content not found." ||
        message == "Failed to export invalid file type."
        ? toastr.error(message, messageTitle)
        : toastr.success(message, messageTitle)
      dispatch(onGetGuests({ status: filterStatus.value, search: searchKey, page: currentPage, size: sizePerPage , startDate: startDate, endDate: endDate}))
      setTimeout(() => {
        resetForm()
        dispatch(clearMessage())
      }, 300)
    }
  }, [dispatch, message])

  useMemo(() => {
    if (!isEmpty(error)) {
      toastr.error(error?.message||error, messageTitle)
      setTimeout(() => {
        dispatch(clearMessage())
      }, 500)
    }
  }, [dispatch, error])

  
  useEffect(() => {
    let payload = {
      size: sizePerPage,
      search: searchKey,
    }
    if (startDate && endDate) {
      payload = {
        ...payload,
        startDate: moment(startDate).format("YYYY-MM-DD"),
        endDate: moment(endDate).format("YYYY-MM-DD"),
      }
    }
    dispatch(onGetGuests({ status: filterStatus.value, search: searchKey, page: currentPage, size: sizePerPage, startDate: startDate, endDate: endDate }))

  }, [startDate, endDate])

  const handleReset = e => {
    setStartDate("")
    setEndDate("")
    setSearchKey("")
    dispatch(onGetGuests({ status: filterStatus.value, search: searchKey, page: currentPage, size: sizePerPage, startDate: startDate, endDate: endDate }))

  }

  const defaultSorted = [
    {
      dataField: "visitDate",
      order: "desc",
    },
  ]


  const guestListColumns = [
    {
      text: "id",
      dataField: "_id",
      sort: true,
      hidden: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, user) => <>{user._id}</>,
    },
    {
      text: "Guest Name",
      dataField: "guestName",
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, guest) => (
        <>
          <h5 className="font-size-14 mb-1">
            <Link to="#" className="text-dark">
              {guest.guestName}
            </Link>
          </h5>
          <p className="text-muted mb-0">{guest.guestId}</p>
          {/* <p className="text-muted mb-0">{guest.guestVehicleNumber}</p> */}
        </>
      ),
    },
    {
      text: "Guest Vehicle Details",
      dataField: "guestVehicleNumber",
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, guest) => (
        <>
          <h5 className="font-size-14 mb-1">
            <Link to="#" className="text-dark">
              {guest.guestVehicleNumber}
            </Link>
          </h5>
          <p className="text-muted mb-0">{guest.guestInVehicleUnit}</p>
        </>
      ),
    },
    {
      dataField: "sponsorName",
      text: "Sponsor Details",
      sort: true,
      formatter: (cellContent, guest) => (
        <>
          <p className="text-muted mb-0">{guest.sponsor?.userId}</p>
          <h5 className="font-size-14 mb-1">
            <Link to="#" className="text-dark">
              {guest.sponsor?.name}
            </Link>
          </h5>
          <p className="text-muted mb-0">{guest.sponsor?.role?.roleTitle}</p>
        </>
      ),
    },
    {
      dataField: "visitDate",
      text: "Last Application Details",
      sort: true,
      formatter: (cellContent, record) => {
        return (
          <>
            <p className="mb-0">
              {moment(record?.visitDate).format("Do MMM YYYY")}
              {"|"} <strong>{record?.carPark?.carParkTitle}</strong>
            </p>
            <p>{record?.purpose || ""}</p>
          </>
        )
      },
    },
    {
      dataField: "status",
      text: "Entry Status",
      sort: true,
      formatter: (cellContent, guest) => (
        <Badge className={"bg-" + getColor(guest?.status)}>
          {guest?.status}
        </Badge>
      ),
    },
    {
      dataField: "menu",
      isDummyField: true,
      editable: false,
      text: "Action",
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, record) => {
        return (
          <div className="d-flex gap-3">
            <Link
              className="text-primary"
              to="#"
              style={{
                opacity: record?.status == "Removed" || moment().startOf("D").diff(moment(record?.visitDate), "days") >= 0 ? "0.4" : 5,
                pointerEvents: record?.status == "Removed" || moment().startOf("D").diff(moment(record?.visitDate), "days") >= 0 ? "none" : "auto",
              }}
            >
              <i
                className="mdi mdi-account-edit font-size-24"
                id="edittooltip"
                onClick={() => handleEditClick(record)}
                data-toggle="tooltip"
                data-placement="top"
                title="Update Guest"
              ></i>
            </Link>
            <Link
              className="text-danger"
              to="#"
              style={{
                opacity: record?.status == "Removed" ||
                  (moment().startOf("D").diff(moment(record?.visitDate), "days") >= 0 &&
                    moment().startOf("D").diff(moment(record?.visitDate), "days") < 7) ? "0.4" : 5,
                pointerEvents: record?.status == "Removed" ||
                  (moment().startOf("D").diff(moment(record?.visitDate), "days") >= 0 &&
                    moment().startOf("D").diff(moment(record?.visitDate), "days") < 7) ? "none" : "auto",
              }}
            >
              <i
                className="mdi mdi-account-minus font-size-24"
                id="deletetooltip"
                onClick={() => onClickDelete(record)}
                data-toggle="tooltip"
                data-placement="top"
                title="Remove Guest"
              ></i>
            </Link>
          </div>
        )
      },
    },
  ]

  const toggle = () => {
    setModal(!modal)
  }

  const handleEditClick = arg => {
    const guest = arg

    setGuest({
      id: guest._id,
      ...guest,
    })
    setSelectedSponsor(getUser(guest?.sponsor || null))
    setSelectedCarpark({
      value: guest?.carPark?._id,
      label: guest?.carPark?.carParkTitle,
    })

    setComplimentaryAccess(
      guest?.status == guestAccessType.Complimentary
    )

    setIsEdit(true)
    if (guest.vehicleType == vehicleTypes.bike) {
      setVehicleType(vehicleTypes.bike)
    } else {
      setVehicleType(vehicleTypes.car)
    }
    toggle()
  }

  var node = useRef()
  const onPaginationPageChange = page => {
    if (
      node &&
      node.current &&
      node.current.props &&
      node.current.props.pagination &&
      node.current.props.pagination.options
    ) {
      node.current.props.pagination.options.onPageChange(page)
    }
  }

  //delete customer
  const [deleteModal, setDeleteModal] = useState(false)

  const onClickDelete = guest => {
    setGuest(guest)
    setDeleteModal(true)
  }

  const handleDeleteGuest = () => {
    dispatch(onDeleteGuest(guest))
    onPaginationPageChange(1)
    setDeleteModal(false)
  }

  const resetForm = () => {
    setVehicleType(vehicleTypes.car)
    setGuest(null)
    setSelectedSponsor(null)
    setSelectedCarpark(null)
    setComplimentaryAccess(false)
    setIsEdit(false)
    setCustValidation({
      validSponsor: true,
      validCarpark: true,
    })
  }

  const handleAddClick = () => {
    resetForm()
    validation.resetForm()
    setIsEdit(false)
    toggle()
  }

  const handleFilter = e => {
    setCurrentPage(1);
    setFilterStatus(e);
    // if (e.value == "All") {
    //   dispatch(onGetGuests({status: "", page: currentPage, size: sizePerPage}))
    // } else {
    //   dispatch(onGetGuests({ status: e.value, page: currentPage, size: sizePerPage}))
    // }
  }

  // Runs when filterStatus is updated, which is from handleFilter function
  useEffect(() => {
    dispatch(onGetGuests({ page: currentPage, size: sizePerPage, status: filterStatus.value, search: searchKey, startDate: startDate, endDate: endDate }));
  }, [filterStatus])

  const handleAccessStatus = e => {
    setCurrentPage(1);
    setAccessStatus(e);
  }

  // Runs when accessStatus is updated, which is from handleAccessStatus function
  useEffect(() => {
    dispatch(onGetGuests({ page: currentPage, size: sizePerPage, status: filterStatus.value, search: searchKey, startDate: startDate, endDate: endDate }));
  }, [accessStatus])

  const keyField = "key_id"
  const sponsorOptions = (users || []).map(el => ({
    value: el._id,
    label: el.name,
  }))

  const carParkOptions = (carParkList || []).map(el => ({
    value: el._id,
    label: el.carParkTitle,
  }))

  let statusTypeOptions = map(guestAccessType, (key, i) => {
    return {
      value: `${key}`,
      label: `${guestAccessType[key]}`,
    }
  })
  statusTypeOptions.unshift({ value: "All", label: "All guest status" })

  let accessTypeOptions = map(guestAccessType, (key, i) => {
    return {
      value: `${key}`,
      label: `${guestAccessType[key]}`,
    }
  })
  accessTypeOptions.unshift({ value: "All", label: "All Guest Entry" })

  const sponsorDetails = (users || []).find(
    el => el._id == (selectedSponsor?.value || "")
  )

  const setDownloadType = () => {
    const exportPayload = {
      // file_type: "csv",
      file_type: fileType.value,
      status: filterStatus.value, search: searchKey, startDate: startDate, endDate: endDate
    }
    dispatch(getExportGuest(exportPayload))
  }

  const handleExport = fileData => {
    // const fileName = `user_post_pms_data` + new Date().getTime() + `.csv`
    const fileName =
      `guest_list_` + new Date().getTime() + `.${fileType.value.toLowerCase()}`
    // const downloadType = "application/vnd.ms-excel"
    const downloadType =
      fileType.value == "csv" || fileType.value == "xlsx"
        ? // ? "application/vnd.ms-excel"
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        : "application/pdf"
    const base64data = `data:${downloadType};base64,${fileData}`
    const downloadLink = document.createElement("a")
    downloadLink.href = base64data
    downloadLink.download = fileName
    downloadLink.click()
    return fileName
  }

  const handleSponser = e => {
    if (e) {
      setSelectedSponsor(e)
      setSelectedCarpark(null);
      const user = userList.find(el => el._id == e.value)
      if (user) {
        setCarparkList(user?.season?.carparks)
      }
    }
  }

  const fileTypeOptions = [
    {
      label: "PDF",
      value: "pdf",
    },
    {
      label: "CSV",
      value: "csv",
    },
    {
      label: "XLSX",
      value: "xlsx",
    },
  ]

  const handleSelectType = e => {
    setFileType(e)
  }

  useEffect(() => {
    if (file) {
      // Call to download file
      handleExport(file)
      setTimeout(() => {
        dispatch(resetExportFileData())
      }, 300)
    }
  }, [file])

  const emptyDataMessage = () => {
    return <p style={{ textAlign: "center" }}>No data to display</p>
  }

  const handleTableChange = () => { }

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteGuest}
        onCloseClick={() => setDeleteModal(false)}
      />

      <Row>
        <Col lg="12">
          <Card>
            <CardBody>
              <PaginationProvider
                pagination={paginationFactory(pageOptions)}
                keyField={keyField}
                columns={guestListColumns}
                data={filteredRes || []}
              >
                {({ paginationProps, paginationTableProps }) => {
                  return (
                    <ToolkitProvider
                      keyField={keyField}
                      data={filteredRes || []}
                      columns={guestListColumns}
                      bootstrap4
                      search
                    >
                      {toolkitProps => (
                        <React.Fragment>
                          <Row className="mb-2">
                            <Col sm="">
                              <Select
                                placeholer={"Select status"}
                                name={"statusType"}
                                value={filterStatus}
                                onChange={e => {
                                  handleFilter(e)
                                }}
                                options={statusTypeOptions}
                                classNamePrefix="select2-selection"
                              />
                            </Col>
                            <Col md="">
                              <input
                                className="form-control"
                                type="date"
                                value={startDate}
                                id="startDate"
                                name="startDate"
                                onChange={e => setStartDate(e.target.value)}
                                onBlur={e => setStartDate(e.target.value)}
                              />
                            </Col>
                            <Col md="">
                              <input
                                className="form-control"
                                type="date"
                                value={endDate}
                                id="endDate"
                                name="endDate"
                                onChange={e => setEndDate(e.target.value)}
                                onBlur={e => setEndDate(e.target.value)}
                              />
                            </Col>   
                            <Col sm="">
                              <Button
                                color="primary"
                                className="font-16 btn-block btn btn-primary"
                                onClick={e => {
                                  toolkitProps.searchProps.onSearch("")
                                  setTimeout(() => {
                                    handleReset(e)
                                  }, 200)
                                }}
                              >
                                Reset
                              </Button>
                            </Col>
                            <Col sm="">
                              <div className="search-box ms-2 mb-2 d-inline-block">
                                <div className="position-relative">
                                  {/* <SearchBar {...toolkitProps.searchProps} />
                                  <i className="bx bx-search-alt search-icon" /> */}
                                  <input
                                    id="search-bar-0"
                                    type="text"
                                    className="form-control "
                                    placeholder="Search"
                                    value={searchKey}
                                    onChange={e => setSearchKey(e.target.value)}
                                  />

                                  <i className="bx bx-search-alt search-icon" />
                                </div>
                              </div>
                            </Col>
                            <Col sm="auto">
                              <div className="text-sm-end d-flex gap-2">
                                <Button
                                  color="primary"
                                  className="font-16 btn-block btn btn-primary"
                                  onClick={handleAddClick}
                                >
                                  <i className="mdi mdi-plus-circle-outline me-1" />
                                  Add New Guest
                                </Button>
                                <div style={{ width: 100 }} className="me-2">
                                  <Select
                                    placeholder={"Select Type"}
                                    name={"File Type"}
                                    value={fileType}
                                    onChange={e => {
                                      handleSelectType(e)
                                    }}
                                    options={fileTypeOptions}
                                    classNamePrefix="select2-selection me-2"
                                  />
                                </div>
                                <Button
                                  color="primary"
                                  className="font-16 btn-block btn btn-primary"
                                  onClick={() => setDownloadType()}
                                >
                                  <i className="bx bx-upload me-1" />
                                  Export
                                </Button>
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col xl="12">
                              <div className="table-responsive">
                                <BootstrapTable
                                  remote
                                  keyField={keyField}
                                  {...toolkitProps.baseProps}
                                  {...paginationTableProps}
                                  defaultSorted={defaultSorted}
                                  classes={
                                    "table align-middle table-nowrap table-hover"
                                  }
                                  bordered={false}
                                  striped={false}
                                  responsive
                                  ref={node}
                                  noDataIndication={emptyDataMessage}
                                  onTableChange={handleTableChange}
                                />

                                <Modal
                                  className={"modal-lg"}
                                  isOpen={modal}
                                  toggle={toggle}
                                >
                                  <ModalHeader toggle={toggle} tag="h4">
                                    {!!isEdit
                                      ? "Update Guest"
                                      : "Add New Guest"}
                                  </ModalHeader>
                                  <ModalBody>
                                    <Form
                                      onSubmit={e => {
                                        e.preventDefault()
                                        validation.handleSubmit()
                                        return false
                                      }}
                                    >
                                      <Row form>
                                        <Col xs={12}>
                                          <Row>
                                            <Col md={6}>
                                              <div className="mb-2">
                                                <label className="form-label">
                                                  Sponsor Name
                                                </label>
                                                <Select
                                                  name="role"
                                                  value={selectedSponsor}
                                                  onChange={e => {
                                                    setCustValidation({
                                                      ...customValidation,
                                                      validSponsor: true,
                                                    })
                                                    handleSponser(e)
                                                  }}
                                                  options={sponsorOptions}
                                                  classNamePrefix="select2-selection"
                                                />
                                                {!customValidation.validSponsor && (
                                                  <div
                                                    className="invalid-feedback"
                                                    style={{ display: "block" }}
                                                  >
                                                    Please select sponsor
                                                  </div>
                                                )}
                                              </div>
                                            </Col>
                                            <Col md={6}>
                                              <div className="mb-2">
                                                <label className="form-label">
                                                  Sponsor Details
                                                </label>
                                                <p className="mt-2 mb-1">
                                                  {sponsorDetails
                                                    ? `${sponsorDetails?.role
                                                      ?.roleTitle || ""
                                                    } | ${sponsorDetails?.department ||
                                                    ""
                                                    }`
                                                    : " - "}
                                                </p>
                                              </div>
                                            </Col>
                                          </Row>
                                          <Row>
                                            <Col lg={12}>
                                              <div className="mb-3">
                                                <Label className="form-label col-lg-2">
                                                  Guest Name*
                                                </Label>
                                                <Input
                                                  name="guestName"
                                                  type="text"
                                                  onChange={
                                                    validation.handleChange
                                                  }
                                                  onBlur={validation.handleBlur}
                                                  value={
                                                    validation.values
                                                      .guestName || ""
                                                  }
                                                  invalid={
                                                    validation.touched
                                                      .guestName &&
                                                      validation.errors.guestName
                                                      ? true
                                                      : false
                                                  }
                                                />
                                                {validation.touched.guestName &&
                                                  validation.errors.guestName ? (
                                                  <FormFeedback type="invalid">
                                                    {
                                                      validation.errors
                                                        .guestName
                                                    }
                                                  </FormFeedback>
                                                ) : null}
                                              </div>
                                            </Col>
                                          </Row>
                                          <Row>
                                            <Col md={3}>
                                              <Row>
                                                <Col>
                                                  <div className="form-check mt-4 mb-1">
                                                    <input
                                                      type="radio"
                                                      id="customRadio1"
                                                      name="customRadio"
                                                      className="form-check-input"
                                                      defaultChecked={
                                                        vehicleType ==
                                                        vehicleTypes.car
                                                      }
                                                      onChange={e =>
                                                        setVehicleType(
                                                          vehicleTypes.car
                                                        )
                                                      }
                                                    />
                                                    <label
                                                      className="form-check-label"
                                                      htmlFor="customRadio1"
                                                    >
                                                      Car
                                                    </label>
                                                  </div>
                                                </Col>
                                                <Col>
                                                  <div className="form-check mt-4">
                                                    <input
                                                      type="radio"
                                                      id="customRadio2"
                                                      name="customRadio"
                                                      className="form-check-input"
                                                      defaultChecked={
                                                        vehicleType ==
                                                        vehicleTypes.bike
                                                      }
                                                      onChange={e =>
                                                        setVehicleType(
                                                          vehicleTypes.bike
                                                        )
                                                      }
                                                    />
                                                    <label
                                                      className="form-check-label"
                                                      htmlFor="customRadio2"
                                                    >
                                                      Bike
                                                    </label>
                                                  </div>
                                                </Col>
                                              </Row>
                                            </Col>
                                            <Col md={4}>
                                              <div className="mb-2">
                                                <Label className="form-label">
                                                  Vehicle Number*
                                                </Label>
                                                <Input
                                                  name="guestVehicleNumber"
                                                  label="guestVehicleNumber"
                                                  type="text"
                                                  onChange={
                                                    validation.handleChange
                                                  }
                                                  onBlur={validation.handleBlur}
                                                  value={
                                                    validation.values
                                                      .guestVehicleNumber || ""
                                                  }
                                                  invalid={
                                                    validation.touched
                                                      .guestVehicleNumber &&
                                                      validation.errors
                                                        .guestVehicleNumber
                                                      ? true
                                                      : false
                                                  }
                                                />
                                                {validation.touched
                                                  .guestVehicleNumber &&
                                                  validation.errors
                                                    .guestVehicleNumber ? (
                                                  <FormFeedback type="invalid">
                                                    {
                                                      validation.errors
                                                        .guestVehicleNumber
                                                    }
                                                  </FormFeedback>
                                                ) : null}
                                              </div>
                                            </Col>
                                            <Col md={5}>
                                              <div className="mb-2">
                                                <Label className="form-label">
                                                  In-vehicle Unit*
                                                </Label>
                                                <Input
                                                  name="guestInVehicleUnit"
                                                  label="guestInVehicleUnit"
                                                  type="text"
                                                  onChange={
                                                    validation.handleChange
                                                  }
                                                  onBlur={validation.handleBlur}
                                                  value={
                                                    validation.values
                                                      .guestInVehicleUnit || ""
                                                  }
                                                  invalid={
                                                    validation.touched
                                                      .guestInVehicleUnit &&
                                                      validation.errors
                                                        .guestInVehicleUnit
                                                      ? true
                                                      : false
                                                  }
                                                />
                                                {validation.touched
                                                  .guestInVehicleUnit &&
                                                  validation.errors
                                                    .guestInVehicleUnit ? (
                                                  <FormFeedback type="invalid">
                                                    {
                                                      validation.errors
                                                        .guestInVehicleUnit
                                                    }
                                                  </FormFeedback>
                                                ) : null}
                                              </div>
                                            </Col>
                                          </Row>
                                          <div className="mb-3">
                                            <h5 className="font-size-14 mb-3 mt-4">
                                              Grant Guest Access
                                            </h5>
                                          </div>
                                          <Row>
                                            <Col md={5}>
                                              <div className="mb-2">
                                                <label className="form-label">
                                                  Carpark
                                                </label>
                                                <Select
                                                  //closeMenuOnSelect={false}
                                                  name={"carParkApplicable"}
                                                  value={selectedCarpark}
                                                  onChange={e => {
                                                    setCustValidation({
                                                      ...customValidation,
                                                      validCarpark: true,
                                                    })
                                                    setSelectedCarpark(e)
                                                  }}
                                                  options={carParkOptions}
                                                  classNamePrefix="select2-selection"
                                                  ref={carparkRef}
                                                />
                                                {!customValidation.validCarpark && (
                                                  <div
                                                    className="invalid-feedback"
                                                    style={{ display: "block" }}
                                                  >
                                                    Please select at least one
                                                    applicable carpark
                                                  </div>
                                                )}
                                              </div>
                                            </Col>
                                            <Col md={4}>
                                              <div className="mb-2">
                                                <Label className="form-label">
                                                  Visit Date
                                                </Label>
                                                <Input
                                                  type="date"
                                                  defaultValue={
                                                    validation.values.visitDate
                                                  }
                                                  id="visitDate"
                                                  name="visitDate"
                                                  onChange={
                                                    validation.handleChange
                                                  }
                                                  invalid={
                                                    validation.touched
                                                      .visitDate &&
                                                      validation.errors.visitDate
                                                      ? true
                                                      : false
                                                  }
                                                />
                                                {validation.touched.visitDate &&
                                                  validation.errors.visitDate ? (
                                                  <FormFeedback type="invalid">
                                                    {
                                                      validation.errors
                                                        .visitDate
                                                    }
                                                  </FormFeedback>
                                                ) : null}
                                              </div>
                                            </Col>
                                            {/* <Col md={3}>
                                              <div className="mb-2">
                                                <Label className="form-label">
                                                  Complimentary Access
                                                </Label>
                                                <Col md={2} className="pt-1">
                                                  <Switch
                                                    checked={
                                                      complimentaryAccess
                                                    }
                                                    onColor="#626ed4"
                                                    onChange={() =>
                                                      setComplimentaryAccess(
                                                        !complimentaryAccess
                                                      )
                                                    }
                                                    uncheckedIcon={
                                                      <OnSymbol text="No" />
                                                    }
                                                    checkedIcon={
                                                      <OffSymbol text="Yes" />
                                                    }
                                                    disabled
                                                  />
                                                </Col>
                                              </div>
                                            </Col> */}
                                          </Row>
                                          <Row>
                                            <Col md={12}>
                                              <div className="mb-2">
                                                <Label className="form-label">
                                                  Purpose
                                                </Label>
                                                <Input
                                                  name="purpose"
                                                  type="textarea"
                                                  onChange={
                                                    validation.handleChange
                                                  }
                                                  onBlur={validation.handleBlur}
                                                  value={
                                                    validation.values.purpose ||
                                                    ""
                                                  }
                                                />
                                              </div>
                                            </Col>
                                          </Row>
                                        </Col>
                                      </Row>
                                      <Row className="mt-4">
                                        <Col>
                                          <div className="text-end">
                                            <button
                                              type="submit"
                                              className="btn btn-success save-user"
                                            >
                                              {!!isEdit
                                                ? "Update Guest"
                                                : "Add New Guest"}
                                            </button>
                                          </div>
                                        </Col>
                                      </Row>
                                    </Form>
                                  </ModalBody>
                                </Modal>
                              </div>
                            </Col>
                          </Row>
                          <Row className="align-items-md-center mt-30">
                            <Col className="pagination pagination-rounded justify-content-end mb-2">
                              <PaginationListStandalone {...paginationProps} />
                            </Col>
                          </Row>
                        </React.Fragment>
                      )}
                    </ToolkitProvider>
                  )
                }}
              </PaginationProvider>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  )
}

export default withRouter(GuestList)
